import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import DataViewer from './pages/DataViewer';
import RecordDetail from './pages/RecordDetail';
import SystemLogs from './pages/SystemLogs';
import Settings from './pages/Settings';
import Login from './pages/Login';
import ApiDocs from './pages/ApiDocs';
import ApiUsers from './pages/ApiUsers';
import Tutorials from './pages/Tutorials';
import TutorialEditor from './pages/TutorialEditor';
import './App.css';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
}

function ProtectedLayout() {
  return (
    <PrivateRoute>
      <Layout>
        <Outlet />
      </Layout>
    </PrivateRoute>
  );
}

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <Router>
      <Routes>
        <Route
          path="/api-docs"
          element={isAuthenticated ? <Layout><ApiDocs /></Layout> : <ApiDocs />}
        />
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" /> : <Login />}
        />

        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/data" element={<DataViewer />} />
          <Route path="/data/:recordId" element={<RecordDetail />} />
          <Route path="/logs" element={<SystemLogs />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/users" element={<ApiUsers />} />
          <Route path="/tutorials" element={<Tutorials />} />
          <Route path="/tutorials/:id/edit" element={<TutorialEditor />} />
        </Route>

        <Route path="*" element={<Navigate to={isAuthenticated ? '/' : '/login'} />} />
      </Routes>
    </Router>
  );
}

export default App;
